class BaseModal {
  constructor(showClose, mes, duration) {
    this.showClose = showClose; // 私有属性关闭弹框
    this.mes = mes; // 私有属性消息
    this.duration = duration; // 私有属性时间
  }
}
export default BaseModal;
